export default __webpack_public_path__ + "static/media/bruno-lucchi.0fa4286a.jpg";